export const GET_ORDERS = "GET_ORDERS";
export const GET_BOOKINGS = "GET_BOOKINGS";
export const CANCEL_ORDER = "CANCEL_ORDER";
